import {EventEmitter, Injectable} from '@angular/core';

import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import { MagicLinkModel, TabModel } from '@shared/models/platform-tool-models';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {ActivatedRoute, Router} from '@angular/router';
import {
  CreateYearlyFilingCommand,
  MapCaseWithTransactionCommand
} from '../commands/dac6-reporter.command';

import {DialogService} from '@shared/services/dialog-service';
import {IDac6ReporterState} from '../store/reducers/dac6-reporter.reducer';

import {take, takeUntil} from 'rxjs/operators';
import {DialogModel} from '@shared/models/dialog.model';
import {Subject} from 'rxjs';
import { FuseSplashScreenService } from '@barebone-fuse/@fuse/services/splash-screen.service';
import { CommandService } from '@core/services/command.service';
import { select, Store } from '@ngrx/store';
import { IQueryState } from '@shared/store/reducers/query.reducer';
import { PlatformCommand } from '@shared/commands/command-base';
import { getQueryResponse } from '@shared/store/selectors/query.selector';
import { QueryProvider } from '@shared/queries/query-provider';
import { GetCheckSumAction } from '@shared/store/actions/particle.actions';
import {Api} from "@shared/constants/common-field.constants";



@Injectable({
  providedIn: 'root'
})

export class PlatformToolDac6TransactionDataHandler implements IPlatformToolHandler {
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  private selectedTabModel: TabModel;
  magicLinkModelValueChanged: EventEmitter<any>;
  currentSelectedItems: string[];
  flag: boolean;
  deleteDisabled: boolean;
  unSubscribe$ = new Subject<void>();
  activatedRoute: ActivatedRoute;
  constructor(
              private router: Router,
              private fuseSplashscreen: FuseSplashScreenService,
              private commandService: CommandService,
              private dialogService: DialogService,
              private store: Store<IDac6ReporterState>,
              private queryState: Store<IQueryState>,
  ) {
  }
  executeCommand(command: PlatformCommand) {
    console.log(command);
    switch (command.name) {
      case 'Dac6TransactionDataExportCommand':
        this.redirectTo(command.fieldValues['RedirectUrl']);
        break;
      case 'Dac6ManageTransactionCommand':
        this.prepareTransactions();
        this.redirectTo(command.fieldValues['RedirectUrl']);
        break;
      case 'Dac6ManageFieldsCommand':
        this.manageSection('Dac6-Transaction');
        break;
    }
  }
  valueChanged(event: any)  {
    if (event.fieldDefinition.key === 'CaseId') {
      const transactionCode = event.item.cells['TransactionCode'].value;
      const dialogModel = DialogModel.create('Assign Case(s)', 'Dac6AssignTransactionCellEditorComponent', {
        caseId: event.item.cells['CaseId'].value,
        item: event.item,
        fieldDefinition: event.fieldDefinition
      });
      dialogModel.minWidth = '400px';
      dialogModel.maxWidth = '400px';
      // dialogModel.componentFactoryResolver = this.componentFactoryResolver;
      this.dialogService.showOkCancelDialog(dialogModel)
        .pipe(takeUntil(this.unSubscribe$))
        .subscribe((actionState: any) => {
          if (actionState && actionState.action === 'OK') {
            const command = new MapCaseWithTransactionCommand(transactionCode, actionState.data.input['CaseIds']);
            this.commandService.executeCommand(command).pipe().subscribe(commandState => {
              this.invalidateSubject.invalidate();
            });
          }

        });
      return;
    }
    if (event.fieldDefinition.key === 'ConsolidatedTable') {
      this.openEditor(event);
      return;
    }
    if (event.item.cells['CaseId'].value === null) {
      this.dialogService.showDialogMessage('Message', 'Please assign a case first');
      return;
    }

    if (event.action && event.action.id === 'OpenCase') {
      this.onSelectCase(event);
      return;
    }
    if (event.action && event.action.id === 'OpenCaseFolder') {
      this.onSelectCase(event);
      return;
    }
    if (event.action && event.action.id === 'CreateAnnualFiling') {
      this.onSelectCase(event);
      return;
    }

    if (event.fieldDefinition.key === 'Hallmarks') {
      this.dialogService.showCellEditorDialog(event.item, event.fieldDefinition).subscribe(state => {
      });
      return;
    }
    if (event.fieldDefinition.key === 'Suggested_Hallmarks') {
      this.dialogService.showCellEditorDialog(event.item, event.fieldDefinition, '500px', '500px').subscribe(state => {
      });
      return;
    }
    if (this.flag) {
      this.currentSelectedItems = [];
    }
    this.flag = false;
    event.deselectedRows.forEach(item => {
      const index = this.currentSelectedItems.indexOf(item.dataItem.id);
      if (index > -1) {
        this.currentSelectedItems.splice(index, 1);
      }
    });
    event.selectedRows.forEach(item => {
      this.currentSelectedItems.push(item.dataItem.id);
    });
    if (this.currentSelectedItems.length > 0) {
      this.deleteDisabled = false;
    } else {
      this.deleteDisabled = true;
    }
  }
  setSelectedTab(selectedTab: TabModel): void {
    this.selectedTabModel = selectedTab;
  }
  destroy(): void {

  }
  selectionChanged?($event: any): void {

  }
  public openEditor(event: any) {
    let minWidth = '400px';
    const maxWidth = '1500px';
    if (event.fieldDefinition.key === 'ConsolidatedTable') {
      minWidth = '1200px';
    }
    this.dialogService.showCellEditorDialog(event.item, event.fieldDefinition, minWidth, maxWidth, this.selectedTabModel.tabData.sourceKey)
      .subscribe(state => {
        console.log('After Edit', state);
        if (state.action === 'OK') {

        }
      });
  }
  private onSelectCase(event: any) {
    const dialogModel = DialogModel.create('Select', 'TransactionCaseDialogsComponent', {
      item: event.item,
      fieldDefinition: event.fieldDefinition
    });
    dialogModel.minWidth = '800px';
    dialogModel.maxWidth = '800px';
    this.dialogService.showOkCancelDialog(dialogModel)
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((actionState: any) => {
        if (actionState && actionState.action === 'OK') {
          this.handleSelectCaseAction(event, dialogModel.input['selectedCase']);
        }

      });
  }
  private handleSelectCaseAction(event: any, selectedCase: any) {
    switch (event.action.id) {
      case 'OpenCase':
        this.router.navigateByUrl('dac6-reporter/transactions/detail/' + selectedCase.arrangementId);
        this.openCaseFromTransactionActivityCommand(event.item.id, selectedCase.caseId);
        break;
      case 'OpenCaseFolder':
        this.navigateToCaseFolder(event, selectedCase);
        if (event.item.id) {
          this.ViewCaseDocumentFromTransactionActivityCommand(event.item.id, selectedCase.caseId);
        }
        break;
      case 'CreateAnnualFiling':
        const command = new CreateYearlyFilingCommand(event.item.id, selectedCase.arrangementId, '', '', {});
        this.commandService.executeCommand(command).subscribe(state => {
          if (state) {
            this.router.navigateByUrl('dac6-reporter/filing/annual');
          }
        });
        break;
    }
  }
  openCaseFromTransactionActivityCommand(transactionId, caseId) {
    const command = new PlatformCommand('OpenCaseFromTransactionActivityCommand', 'Dac6Api');
    command.fieldValues['TransactionId'] = transactionId;
    command.fieldValues['CaseId'] = caseId;
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(response => {
        console.log('commandState', response);
      },
      error => {
        console.error('Failed to basket manage section', error);
      });
  }
  ViewCaseDocumentFromTransactionActivityCommand(transactionId, caseId) {
    const command = new PlatformCommand('ViewDocumentActivityCommand', 'Dac6Api');
    command.fieldValues['TransactionId'] = transactionId;
    command.fieldValues['CaseId'] = caseId;
    command.fieldValues['SourceType'] = 'Dac6-Transaction';
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(response => {
        console.log('commandState', response);
      },
      error => {
        console.error('Failed to basket manage section', error);
      });
  }
  navigateToCaseFolder(event: any, selectedCase: any) {
    if (event.action && event.action.tags.length) {
      let relativePath = event.action.tags[0];
      const caseId = selectedCase.caseId;
      relativePath = relativePath.replace('[CASE_ID]', caseId);
      relativePath = relativePath.replace('Filings', 'Arrangements');
      const relativeUrl$ = this.queryState.pipe(select(getQueryResponse, 'UrlByRelativePath'))
        .pipe(take(2));
      relativeUrl$.subscribe((state: any) => {
        if (state) {
          this.router.navigateByUrl(state);
        }
      });

      QueryProvider.invokeQuery(this.queryState, 'UrlByRelativePath', {'[RELATIVE_PATH]': relativePath});

    }
  }
  redirectTo(url) {
    this.router.navigateByUrl(url);
  }
  private prepareTransactions() {
    this.store.dispatch(new GetCheckSumAction('[CompanyId]-dac6-manage-transaction-workflow', 'Dac6Api'));
  }
  manageSection(sourceType: string) {
    const command = new PlatformCommand('CreateManageFieldMagicLinkCommand', Api.DAC6);
    command.fieldValues['SourceType'] = sourceType;
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe((response: any) => {
        console.log('commandState', response);
        if (response.fieldValues['RedirectUrl']) {
          this.router.navigateByUrl(response.fieldValues['RedirectUrl']);
        }
      },
      error => {
        console.error('Failed to managesection', error);
      });
  }
}
